<!-- begin::Footer -->
<div class="m-container m-page__container m-container--full-height" [ngClass]="footerContainerClass$ | async">
	<div class="m-footer__wrapper">
		<div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
			<div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
			<span class="m-footer__copyright">
				{{ date }} &copy; Adelphi Kitchens
			</span>
			</div>
			<div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
				<ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
					<li class="m-nav__item mr-3">
						<a href="https://adelphikitchens.com/about/" class="m-nav__link" target="_blank">
							<span class="m-nav__link-text">
								About
							</span>
						</a>
					</li>
					<!-- <li class="m-nav__item mr-3">
						<a href="#" class="m-nav__link">
						<span class="m-nav__link-text">
							Privacy
						</span>
						</a>
					</li> -->
					<li class="m-nav__item mr-3">
						<a [routerLink]="getTermsAndConditionsLink()" class="m-nav__link">
						<span class="m-nav__link-text" style="cursor:pointer;">
							Terms and Conditions
						</span>
						</a>
					</li>
					<li class="m-nav__item mr-3">
						<a [routerLink]="getPrivacyPolicyLink()" class="m-nav__link">
						<span class="m-nav__link-text" style="cursor:pointer;">
							Privacy Policy
						</span>
						</a>
					</li>
					<li class="m-nav__item mr-3" *ngIf="trial$ | async">
						<a [routerLink]="['/' + getModulePrefix(), 'pricing']" class="m-nav__link">
						<span class="m-nav__link-text">
							Purchase
						</span>
						</a>
					</li>
					<!-- <li class="m-nav__item mr-3 m-nav__item">
						<a href="#" class="m-nav__link" data-toggle="m-tooltip" title="Support Center" data-placement="left">
							<i class="m-nav__link-icon flaticon-info m--icon-font-size-lg3"></i>
						</a>
					</li> -->
				</ul>
			</div>
		</div>
	</div>
</div>
<!-- end::Footer -->
